import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Varsa genel stiller
import App from './App.jsx';
//import reportWebVitals from './reportWebVitals'; // Varsa performans ölçüm dosyası

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Varsa performans ölçüm dosyası, aksi halde yorumlayın veya silin
// reportWebVitals();
